/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Extremely_HighInputs */

const en_extremely_high = /** @type {(inputs: Extremely_HighInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Extremely High`)
};

const th_extremely_high = /** @type {(inputs: Extremely_HighInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`สูงสุด`)
};

const ja_extremely_high = /** @type {(inputs: Extremely_HighInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`極めて高い`)
};

const fr_extremely_high = /** @type {(inputs: Extremely_HighInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Extrêmement élevé`)
};

const es_extremely_high = /** @type {(inputs: Extremely_HighInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Extremadamente alto`)
};

const ru_extremely_high = /** @type {(inputs: Extremely_HighInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Крайне высокий`)
};

const zh_extremely_high = /** @type {(inputs: Extremely_HighInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`极高`)
};

const vi_extremely_high = /** @type {(inputs: Extremely_HighInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cực cao`)
};

/**
* | output |
* | --- |
* | "Extremely High" |
*
* @param {Extremely_HighInputs} inputs
* @param {{ locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }} options
* @returns {LocalizedString}
*/
export const extremely_high = /** @type {((inputs?: Extremely_HighInputs, options?: { locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Extremely_HighInputs, { locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_extremely_high(inputs)
	if (locale === "ja") return ja_extremely_high(inputs)
	if (locale === "fr") return fr_extremely_high(inputs)
	if (locale === "es") return es_extremely_high(inputs)
	if (locale === "ru") return ru_extremely_high(inputs)
	if (locale === "zh") return zh_extremely_high(inputs)
	if (locale === "vi") return vi_extremely_high(inputs)
	return en_extremely_high(inputs)
});